import React from 'react';
import { Link } from 'react-router';
import logo from './noiz-logo.png';
import logoBlack from './noiz-logo-black.png';

function Logo({ black }) {
  return (
    <Link
      href="/"
      to="/"
    >
      <div
        className="logo"
        style={{ backgroundImage: `url(${black ? logoBlack : logo})`}}
      />
    </Link>
  );
}

export default Logo;
